import './spinner.scss';

export default function Spinner(props) {
    let size = props?.size || 'normal';

    return (
        <div className={`SpinnerWrapper${size === 'normal' ? '' : ' ' + size}`}>
            <div className="Spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
}
